import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=18ec7eff&scoped=true&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec7eff",
  null
  
)

export default component.exports